import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    stepProgress: (current: number, total: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Step counter in multi-step onboarding tooltips (e.g. "1 of 2") */
            stepProgress: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (current: number, total: number) => __intl__.intl().formatMessage({ id: "OnboardingTooltipBody.stepProgress?c=2tui6v0jalj26", defaultMessage: "{current, number} of {total, number}" }, { current: current, total: total }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
